import {
  cssPropertyToDefaultValueMap,
  generateSkinDefaults,
} from '@wix/editor-elements-panel';

export type SiteAssetsSkinParams = Parameters<
  typeof generateSkinDefaults
>[0][string];

export const textEffectsSharedSkin = {
  'letter-spacing': {
    type: 'SIZE',
    defaultValue: 'unset',
  },
  'line-height': {
    type: 'SIZE',
    defaultValue: 'unset',
  },
  'text-align': {
    type: 'TEXT_ALIGN',
    defaultValue: 'start',
  },
  'text-transform': {
    type: 'TEXT_TRANSFORM',
    defaultValue: cssPropertyToDefaultValueMap['text-transform'],
  },
  font: {
    type: 'FONT',
    defaultValue: 'font_8',
  },
  minFontSize: {
    type: 'SIZE',
  },
  maxFontSize: {
    type: 'SIZE',
  },
} as const satisfies SiteAssetsSkinParams;

const textEffectsSharedSkinDefinitionMap: Record<string, SiteAssetsSkinParams> =
  {
    'wixui.skins.TextEffectsShared': textEffectsSharedSkin,
  };

export default generateSkinDefaults(textEffectsSharedSkinDefinitionMap);
